import styled from 'styled-components/macro'
import { Box } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { FLEX_CONTAINER } from 'utils/styles'

const MotionBox = motion(Box)

export const StyledMotionBox = styled(MotionBox)`
  ${FLEX_CONTAINER.FlexColumn}
  margin: auto;
  width: 368px;
  position: fixed;
  flex-direction: column;
  bottom: 0;
  left: 50%;
  gap:16px;
  overflow: scroll;
  margin-inline: auto;
  margin-block: 60px;
  background-color: white;
  border-radius: 10px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar{
    display: none
  }
`
